"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var secp256k1_1 = require("secp256k1");

var constants_1 = require("./constants");

var address_1 = require("./address");

var buffer_1 = require("./buffer");

var hex_1 = require("./hex");

var keccak_1 = require("./keccak");

function verifyPublicKey(publicKey) {
  var buffer = buffer_1.toBuffer(publicKey, null);
  return buffer && secp256k1_1.publicKeyVerify(buffer);
}

exports.verifyPublicKey = verifyPublicKey;

function verifyPrivateKey(privateKey) {
  var buffer = buffer_1.toBuffer(privateKey, null);
  return buffer && secp256k1_1.privateKeyVerify(buffer);
}

exports.verifyPrivateKey = verifyPrivateKey;

function privateToPublicKey(privateKey) {
  var result = null;

  if (verifyPrivateKey(privateKey)) {
    var buffer = buffer_1.toBuffer(privateKey, null);
    result = hex_1.toHex(secp256k1_1.publicKeyCreate(buffer, false));
  }

  return result;
}

exports.privateToPublicKey = privateToPublicKey;

function randomPrivateKey() {
  var result = null;

  for (;;) {
    result = hex_1.randomHex(32);

    if (verifyPrivateKey(result)) {
      break;
    }
  }

  return result;
}

exports.randomPrivateKey = randomPrivateKey;

function publicKeyToAddress(publicKey) {
  var result = null;

  try {
    if (verifyPublicKey(publicKey)) {
      var hash = keccak_1.keccak256("".concat(constants_1.HEX_PREFIX).concat(publicKey.slice(4))).slice(2);
      result = address_1.toChecksumAddress("".concat(constants_1.HEX_PREFIX).concat(hash.slice(-40)));
    }
  } catch (err) {
    result = null;
  }

  return result;
}

exports.publicKeyToAddress = publicKeyToAddress;